"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {loadGroup, loadGroupPRRList, loadGroupPRRTabs,} from "@/service";
import {Divider, SimpleGrid, UnstyledButton} from "@mantine/core";
import {IGroupDTO, IPolicyResearchResultsDTO} from "@/form/group";
import Image from 'next/image'
import {ReadMoreNoLink} from "@/app/(index)/read-more";
import styles from "@/app/(index)/index.module.css";
import {loadCurrentFontSize} from "@/app/(index)/util";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700', '800', '900'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const groupName: {[key: string]: {[key: string]: string}} = {
    A: {name1: "政策研究", name2: "政策", name3: "Policy Research"},
    B: {name1: "科研資料服務", name2: "科研資料", name3: "Databases & Information Service"},
    C: {name1: "科技產業", name2: "科技產業", name3: "Science & Technology Industry"},
    D: {name1: "創新創業", name2: "創新創業", name3: "Innovation & Entrepreneurship Promotion"},
}

const Page = ({ params }: { params: { id: string } }) => {
    const { fontSize, lang } = useGlobalStateStore();
    // const loadCurrentFontSize = (s: number, m: number, l: number) => {
    //     if(fontSize == 0) return `text-[${s}px]`;
    //     else if(fontSize == 1) return `text-[${m}px]`;
    //     else if(fontSize == 2) return `text-[${l}px]`;
    // }

    const [entity, setEntity] = useState<IGroupDTO | null>(null);
    const [pprData, setPprData] = useState<{[key: string]: string[] | IPolicyResearchResultsDTO[]}>({});
    const [tab, setTab] = useState<string>('');
    const [prrTab, setPrrTab] = useState<string[]>([]);
    const [prrList, setPrrList] = useState<IPolicyResearchResultsDTO[]>([]);

    useEffect(() => {
        loadGroup(params.id)
            .then(data => {
                setEntity(data);
            })

        Promise.all([loadGroupPRRList(params.id), loadGroupPRRTabs(params.id)])
            .then(([prrList, prrTab]) => {

                console.log("promise all done.....");
                console.log(JSON.stringify(prrList));

                setPrrList(prrList??[]);
                if(prrTab?.length??0 > 0){
                    setTab(prrTab!![0]);
                    setPrrTab(prrTab??[]);
                }
            })
    }, []);

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name={`${groupName[params.id]["name1"]} - ${groupName[params.id]["name2"]}核心研究團隊`}
                               name_e={`${groupName[params.id]["name3"]} - ${groupName[params.id]["name3"]} Division`}
                        />
                    )
                }

                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" && <>{groupName[params.id]["name2"]}核心研究團隊</>}
                        {lang == "en" && <>{groupName[params.id]["name3"]} Division</>}
                    </div>
                    <div className="text-[20px] leading-[40px] text-justify">
                        {lang == "tw" ? entity?.intro : entity?.introEn}
                    </div>
                    <Divider color={"#cedbdc"} my={35} mb={30}/>
                    <SimpleGrid cols={mediaQueryLessSM ? 3 : 1}>
                        {entity?.teams?.filter(item => lang == "tw" || item.nameEn != "--").map((item, i) => (
                            <UnstyledButton key={`team-${i}`} mb={80} component="a"
                                            href={`/group/${params.id}/${item.temId}`}>
                                <div className="group">
                                    <Image src={`${process.env.NEXT_PUBLIC_API_HOST}/image/${item.coverArhId?.arhId}`}
                                           className="border border-[#abd0cb] rounded-[20px]"
                                           width={379} height={251} alt={"team logo"}/>
                                    <div
                                        className="text-[#158a83] text-[22px] font-bold mt-[10px] group-hover:text-black">
                                        {lang == "tw" ? item.name : item.nameEn}
                                    </div>
                                    <div className="mt-[25px]">
                                        <ReadMoreNoLink/>
                                    </div>
                                </div>
                            </UnstyledButton>
                        ))}
                    </SimpleGrid>
                </div>

                {
                    prrList.length > 0 && (
                        <div className={cx("bg-[#f2f5f6] pt-[45px]", mediaQueryLessSM ? '' : 'px-[10px]')}>
                            <div className="w-[1250px] mx-auto pb-[100px]">
                                <div className="font-bold text-[27px]">團隊研究成果</div>
                                <div className="flex justify-end gap-1 border-b border-[#79b7b4]">
                                    {
                                        prrTab?.map((tabName, i) => (
                                            <UnstyledButton key={`prrtab-${i}`} onClick={() => setTab(tabName)}>
                                                <div
                                                    className={cx(tab === tabName ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                                        "text-white py-[10px] px-[35px] font-bold", loadCurrentFontSize(14, 18, 20, fontSize))}>
                                                    {tabName}
                                                </div>
                                            </UnstyledButton>
                                        ))
                                    }
                                </div>
                                    <SimpleGrid cols={mediaQueryLessSM ? 4 : 1} className="divide-x divide-[#ccc] divide-dotted" pt={25}>
                                        {
                                            prrList.map((item, i) => (
                                               <div key={`prr-list-${i}`} className={cx("px-[25px] py-[22px]", (tab == item.tabName || prrTab.length == 0)  ? 'block' : 'hidden')}>
                                                   <UnstyledButton className="flex flex-col " component="a" target="_blank" href={`${item.linkUrl}`}>
                                                       <div className="mb-[35px]">
                                                           <Image
                                                               src={`${process.env.NEXT_PUBLIC_API_HOST}/image/original/${item.arhId?.arhId}`}
                                                               width={241} height={96} alt={"team logo"}/>
                                                       </div>
                                                       <div className="text-[20px] font-bold leading-[24px]">
                                                           {item.title}
                                                       </div>
                                                       <div className="text-[15px] text-[#b6b6b6] font-bold mt-[5px] break-all">
                                                           {item.linkUrl}
                                                       </div>
                                                       <div className="mt-[25px]">
                                                           <ReadMoreNoLink/>
                                                       </div>
                                                   </UnstyledButton>
                                               </div>
                                            ))
                                        }
                                    </SimpleGrid>
                            </div>
                        </div>
                    )
                }
            </div>


            <Footer/>
        </div>
    );
}

export default Page
